import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectIsAnswerRefInRefs } from 'store/player/playerSelectors';
import { selectQuiz } from 'store/quiz/quizSelectors';
import QuizTypes from 'types/QuizTypes';
import IAnswer from 'models/Answer';
import { RootState } from 'store';
// Component
import { Button } from 'components/Buttons';
// Icons
import { FaStar } from "react-icons/fa";

type Props = {
  answer: IAnswer;
  onClick: (answerRef:string) => void;
  disabled?: boolean;
  blured?: boolean;
};

const AnswerButton:FC<Props> = ({
  // Props
  answer, onClick, disabled = false, blured = false
}) => {
  // State
  const quiz = useAppSelector(selectQuiz);
  const isAnswerRefInRefs:boolean = useAppSelector((state:RootState) => selectIsAnswerRefInRefs(state, {
    answerRef: answer.ref
  }));

  const isPollQuiz = quiz.type === QuizTypes.Poll;

  return (
    <Button
      className={`
         text-xl font-bold 
        ${isAnswerRefInRefs
          ? `${isPollQuiz
            ? `flex items-center justify-between text-white
                bg-[url('assets/images/button-bg.png')] bg-cover bg-center bg-no-repeat hover:bg-[url('assets/images/button-bg.png')]`
            : 'bg-linear-orange text-white'}`
          : 'bg-linear text-[#242324]'
        }
      `}
      onClick={() => onClick(answer.ref)}
      disabled={blured || disabled}
    >
      {isAnswerRefInRefs && isPollQuiz && <FaStar className="text-[#f1de0e] ml-2" />}
      <span className={blured ? 'blur-sm select-none' : ''}>{answer.title}</span>
      {isAnswerRefInRefs && isPollQuiz && <FaStar className="text-[#f1de0e] mr-2" />}
    </Button>
  )
}

export default AnswerButton;
